<template>
  <div v-if="!isShowingLoading" :class="$style['container']">
    <SideBar />

    <div :class="[$style['content'], {[$style['menuExpaned']]: isMenuExpanded}]">

      <ReportsTable />

      <PerformanceTable />

    </div>

  </div>

</template>

<script>

import SideBar from '@components/SideBar.vue';
import ReportsTable from '@/components/reports/ReportsTable.vue';
import PerformanceTable from '@/components/reports/PerformanceTable.vue';

export default {
  name: 'ReportsPage',

  data() {
    return {
      loading: true,
      performances: []
    };
  },

  components: {
    SideBar,
    ReportsTable,
    PerformanceTable
  },

  mounted() {
    this.$store.dispatch('helpers/hideLoading')
  },

  computed: {
    isMenuExpanded() {
      return this.$store.getters['helpers/isMenuExpanded'];
    },
    isShowingLoading() {
      return this.$store.getters['helpers/isShowingLoading'];
    },
  },

}
</script>

<style lang="scss" module>
  .container {
    // padding: 32px;
    width: 100%;
    display: flex;

    .content {
      flex: 1;
      padding: 20px 20px 20px 0;
      overflow-x: hidden;
      overflow-y: scroll;

      &.menuExpaned {
        position: absolute;
        margin-left: 45px;
        height: 100%;
        width: -webkit-fill-available;

        .wrapper-report {
          position: absolute;
          width: 90%;
        }
      }
    }

  }
</style>
